import { Component, OnInit } from '@angular/core';
import { PrFormConstructor } from '@app/components/pr-form/pr-form.contructor';
import { UntypedFormArray } from '@angular/forms';
import { EaSubscriptionBuilder } from './ea-subscription-form.builder';
import { SubscriptionFacadeService } from '@app/forms/subscription/services/subscription-facade.service';

import {
  sustainabilityOptions,
  taxonomyOptions,
} from '@app/forms/subscription/services/ref';
@Component({
    selector: 'taxonomy',
    templateUrl: './taxonomy.component.html',
    styleUrls: ['./taxonomy.component.scss'],
    standalone: false
})
export class TaxonomyComponent extends EaSubscriptionBuilder implements OnInit {
  taxonomyOptions = taxonomyOptions;
  sustainabilityOptions = sustainabilityOptions;
  constructor(
    protected formConstructor: PrFormConstructor,
    private subscriptionFacade: SubscriptionFacadeService,
  ) {
    super(formConstructor);
  }

  ngOnInit() {
    this.subscriptionFacade.initForm(this);
  }
  get owners() {
    return this.form.get('owners') as UntypedFormArray;
  }
  onSubmit() {
    this.form.markAsDirty();
    this.subscriptionFacade.submitPledge(this);
  }

  prev() {
    this.subscriptionFacade.previousStep();
  }
}
